import React, {useState, useEffect, useRef, useContext, useCallback} from 'react';
import useKeyPress from '../../../../hooks/useKeyPress';
import {numbers, specialCharTextNumbers} from '../../../views/textNumber-input/text-number';
import TextNumberEntryView from '../../../views/textNumberEntryView';
import NumberView from '../../../views/numberTNView';
import MenuContext from '../../../../context/menuContext';
import ValuesContext from '../../../../context/valuesContext';

function RefreshRateTN({onExit, isDisabled}) {
  const [value, setValue] = useState(10);
  const {selected, setDisableMenu} = useContext(MenuContext);
  const {values, onUpdateValues} = useContext(ValuesContext);

  const onRightHold = useCallback(
    result => {
      setDisableMenu(true);
      onExit();
      onUpdateValues(selected.id, result);
      setTimeout(() => setDisableMenu(false), 500);
    },
    [value],
  );

  return (
    <NumberView
      chars={numbers}
      focus={10}
      onChange={v => setValue(v)}
      defaultKey1={0}
      defaultKey2={0}
      defaultKey3={0}
      defaultKey4={0}
      defaultKey5={0}
      defaultKey6={0}
      defaultKey7={0}
      defaultKey8={0}
      defaultKey9={0}
      defaultKey10={4}
      defaultKey11={7}
      defaultKey12={2}
      onSave={onRightHold}
      onLeftHold={onExit}
      title="Refresh Rate"
      caption="Set Refresh Rate in milliseconds."
      left="Hold to Cancel"
      right="Hold to Save"
    />
  );
}

export default RefreshRateTN;
